import { useNotify, useRecordContext, useRefresh, useTranslate } from 'react-admin'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material'
import EventIcon from '@mui/icons-material/Event'
import { blue } from 'src/assets/colors'
import { getDay } from '../../helper/getDay'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISION_VIEW_CANCEL_SUPPLIER } from 'src/helper/Permission'
import EditIcon from '@mui/icons-material/Edit';
import { useEffect, useState } from 'react'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { itemServices } from 'src/services/reservation/item/item.service'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'
import { LoadingButton } from '@mui/lab'
import { useComments } from './CommentsContext'

export const ItemCancellation = ({ autoCancelDate, cancellations }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const item = useRecordContext()
  const [openEditDialog, setOpenEditDialog] = useState(false)
  const [newCancelationDate, setNewCancelationDate] = useState(autoCancelDate)
  const [loadingDateUpdate, setLoadingDateUpdate] = useState(false)
  const [supplierIndex, setSupplierIndex] = useState(null)
  const {setReloadGrid} = useComments()
  const [cancelId, setCancelId] = useState(null)
  const [maxSupplierDate, setMaxSupplierDate] = useState(null)

  const formatDateUtc = (date) =>{
    if(date){
      const [year, month, day] = date?.split('-')
      return new Date(year, month - 1, day)
    }

    return null
  }

  const suppliersDate = cancellations?.filter((elem) => !elem.is_client_cancel) ?? []
  const generalSupplierDate = suppliersDate?.[0]?.date ? formatDateUtc(suppliersDate[0].date?.split(' ')?.[0]) ?? null : null

  useEffect(()=>{
    if(cancelId){
      setOpenEditDialog(true)
      const cancelDate = cancellations.find(cancel=>cancel.id === cancelId)?.date ?? ''
      if(cancelDate){
        setNewCancelationDate(formatDateUtc(cancelDate.split(' ')?.[0]))
      }
    }
  },[cancelId])

  const onUpdateCancelationDate = async() =>{
    if(newCancelationDate){
      const dateParte = newCancelationDate.toISOString()?.split('T')?.[0];
      if(cancelId){
        setLoadingDateUpdate(true)
        await itemServices.updateAutoncancelDate(cancelId, dateParte).then(()=>{
          notify('ra.notification.due_date_success',{type:'success'})
          setOpenEditDialog(false)
          refresh()
          setCancelId(null)
          setReloadGrid(prev=>!prev)
        }).catch(()=>{
          notify('ra.notification.due_date_error',{type:'error'})
        }).finally(()=>{
          setLoadingDateUpdate(false)
        })
      } else {
        setLoadingDateUpdate(true)
        await itemServices.updateAutoncancelDateItem(item.item_id, dateParte).then(()=>{
          notify('ra.notification.due_date_success',{type:'success'})
          setOpenEditDialog(false)
          refresh()
          setReloadGrid(prev=>{console.log("prevv", !prev); return !prev})
        }).catch((error)=>{
            if(error.response?.data?.detail){
                notify(error.response?.data?.detail,{type:'error'})
            } else {
                notify('ra.notification.due_date_error',{type:'error'})
            }
          
        }).finally(()=>{
          setLoadingDateUpdate(false)
        })
      }
    }
    
  }

  const onClose = () =>{
    setCancelId(null)
    setOpenEditDialog(false)
  }

  const isEnabledAutoCancel = () =>{
    return hasPermissionFunction('cancel-info', 'full_edit') ||
      (
        (
        ((new Date()) <  generalSupplierDate) /* &&
        ((new Date()) <  cancellation_three_days) */)
        &&
        item.status === 'CONFIRMED'
      )
  }

  const isEnabled = (cancellation, supplier) =>{
    const supplier_date_one = new Date(supplier)
    const supplier_date_two = new Date(supplier)
    const cancellation_three_days = new Date(cancellation)
    cancellation_three_days.setDate(cancellation_three_days.getDate() + 4)
    supplier_date_one.setDate(supplier_date_one.getDate() - 1)
    supplier_date_two.setDate(supplier_date_two.getDate() - 2)
    return (hasPermissionFunction('cancel-info', 'full_edit') &&
        ((new Date()) <  supplier_date_one)
      ) ||
      (hasPermissionFunction('cancel-info', 'edit')  &&
        ((new Date(cancellation) <  supplier_date_one) &&
        ((new Date()) <  supplier_date_one) /* &&
        ((new Date()) <  cancellation_three_days) */)
        &&
        item.status === 'CONFIRMED'
      ) ||
      (
        hasPermissionFunction('cancel-info', 'partial_edit')  &&
        ((new Date(cancellation) <  supplier_date_two) &&
        ((new Date()) <  supplier_date_two) /* &&
        ((new Date()) <  cancellation_three_days) */)
        &&
        item.status === 'CONFIRMED'
      ) 
  }

  const getCancellations = (title, items) => {
    if (items) {
      return (
        <>
          <Typography variant='h7' component='div' fontWeight={600}>
            {title}
          </Typography>
          <Box style={{ padding: '10px' }}>
            {items.map((cancellation, index) => 
            {
            let supplierDate = cancellations.filter((elem) => !elem.is_client_cancel)[index]?.date ?? null
            supplierDate = formatDateUtc(supplierDate?.split(' ')?.[0])
            supplierDate?.setDate(supplierDate?.getDate() - 2)
            const formattedCacelationDate = formatDateUtc(cancellation?.date?.split(' ')?.[0])
            return (
              <Box className='cancellation_container' key={index}>
                <Box className='cancellation_column'>
                  <Typography variant='h7' component='div' fontWeight={600}>
                    {translate('ra.field.date')}:
                  </Typography>
                  <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                    <Typography variant='h7' component='div' className='cancellation_column_value'>
                      <EventIcon /> {getDay(cancellation?.date)}
                    </Typography>
                    {
                      cancellation.is_client_cancel && 
                      (
                      hasPermissionFunction('cancel-info', 'full_edit')
                      ) &&
                      <EditIcon 
                        style={{cursor:'pointer', marginLeft:'10px'}} 
                        fontSize='small'
                        color={ 'info'}
                        onClick={()=>{
                          /* if(isEnabled(formattedCacelationDate , supplierDate)){ */
                            setSupplierIndex(index)
                            setCancelId(cancellation.id)
                            if(supplierDate){
                              setMaxSupplierDate(supplierDate)
                            }
                          /* } */
                        }}
                      />
                    }
                  </div>
                </Box>
                <Box className='cancellation_column'>
                  <Typography variant='h7' component='span' fontWeight={600}>
                    {translate('ra.field.amount')}:
                  </Typography>
                  <Typography variant='h7' component='div' className='cancellation_column_value'>
                    $ {numberFormatterWithDecimalAndThousand(cancellation?.amount)}
                  </Typography>
                </Box>
              </Box>
            )})}
          </Box>
        </>
      )
    }
  }

  const getMaxDate = () =>{
    if(!hasPermissionFunction('cancel-info', 'full_edit') ){
        /* const refDate = new Date(refCancelationDate)
        refDate.setDate(refDate.getDate() + 3)
        return Math.min(refDate, maxSupplierDate) */
      return maxSupplierDate
    } else {
      if(!cancelId){
        return maxSupplierDate
      } else {
        const supplierDate = cancellations.filter((elem) => !elem.is_client_cancel)[supplierIndex]
        if(supplierDate){
          let formattedDate = formatDateUtc(supplierDate?.date?.split(' ')?.[0])
          formattedDate.setDate(formattedDate.getDate() -1)
          return formattedDate
        }
      }
    }
  }

  const getDaysFromSupplierDate = () =>{
    if(hasPermissionFunction('cancel-info', 'full_edit') || hasPermissionFunction('cancel-info', 'partial_edit') ){
      return 1
    }
    return 2
  }

  if (cancellations && cancellations.length !== 0) {
    return (
      <Box>
        <Typography variant='h6' component='div' color={blue} margin={'25px 0px 10px 0px'}>
          {translate('ra.title.cancellation_cost')}
        </Typography>
        {hasPermissionFunction('cancel-info', PERMISION_VIEW_CANCEL_SUPPLIER) &&
          getCancellations(
            translate('ra.title.cancellation_cost_provider'),
            cancellations.filter((elem) => !elem.is_client_cancel)
          )}
        {getCancellations(
          translate('ra.title.cancellation_cost_client'),
          cancellations.filter((elem) => elem.is_client_cancel)
        )}
        <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
          <ShowElement data={autoCancelDate} label={translate('ra.field.autocancel_date')} date />
          {
            autoCancelDate && 
            (hasPermissionFunction('cancel-info', 'edit') ||
            hasPermissionFunction('cancel-info', 'full_edit')) &&
              <EditIcon 
                style={{cursor:isEnabled(formatDateUtc(autoCancelDate), generalSupplierDate)?'pointer':'inherit', marginLeft:'10px'}} 
                fontSize='small' color={isEnabled(formatDateUtc(autoCancelDate), generalSupplierDate) ? 'info' : 'disabled'} 
                onClick={()=>{
                  if(isEnabled(formatDateUtc(autoCancelDate), generalSupplierDate)){
                    if(generalSupplierDate){
                      let generalSupplierDateAux = new Date(generalSupplierDate)
                      generalSupplierDateAux.setDate(generalSupplierDateAux.getDate() - getDaysFromSupplierDate())
                      setMaxSupplierDate(generalSupplierDateAux)
                    }
                    setOpenEditDialog(true); 
                    setNewCancelationDate(formatDateUtc(autoCancelDate))
                  }
                }}/>
          }
        </div>

        <Dialog open={openEditDialog} onClose={onClose}>
          <DialogTitle>
            {`${translate('ra.action.update')} ${translate('ra.field.autocancel_date')}`}
          </DialogTitle>
          <DialogContent>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
              <DatePicker
                  value={newCancelationDate|| null}
                  id='from'
                  minDate={new Date()}
                  maxDate={getMaxDate()}
                  onChange={(date) => setNewCancelationDate(date)}
                  renderInput={(params) => (
                    <TextField {...params} required  style={{width:'100%'}} fullWidth variant='outlined' size='small' />
                  )}
                />
            </LocalizationProvider>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={onClose}
            >
              {translate('ra.action.close')}
            </Button>
            <LoadingButton
              onClick={onUpdateCancelationDate}
              loading={loadingDateUpdate}
            >
              {translate('ra.action.edit')}
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </Box>
    )
  }
}